/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react';
import { toAbsoluteUrl } from 'src/_metronic/helpers';
import { APP_ANDROID_URL, APP_IOS_URL, detectMobilePlatform, getStoreUrlForPlatform } from '../app-download';

export function AppDownloadRedirect() {
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    const platform = detectMobilePlatform();
    const target = getStoreUrlForPlatform(platform);
    if (target) {
      setRedirecting(true);
      window.location.replace(target);
    }
  }, []);

  const hasIos = Boolean(APP_IOS_URL);
  const hasAndroid = Boolean(APP_ANDROID_URL);

  return (
    <div className="d-flex flex-column flex-center min-vh-100 bg-white p-10">
      <div className="w-100 w-lg-450px bg-white border border-gray-300 rounded shadow-sm p-8 p-lg-12 text-center">
        <h1 className="text-dark fw-bolder fs-2 mb-3">idefix Satıcı Uygulaması</h1>
        <p className="text-gray-600 fs-6 mb-8">
          {redirecting ? 'Uygulama mağazasına yönlendiriliyorsunuz...' : 'Uygulamayı indirmek için mağazanızı seçin.'}
        </p>

        <div className="d-flex flex-column gap-3">
          {hasIos && (
            <a href={APP_IOS_URL} className="btn btn-light border border-gray-300 d-flex align-items-center justify-content-center gap-2">
              <img src={toAbsoluteUrl('/media/svg/brand-logos/apple-black.svg')} alt="" style={{ height: 20 }} />
              <span className="fw-bold">
                App Store'dan <span className="text-primary">indir</span>
              </span>
            </a>
          )}
          {hasAndroid && (
            <a href={APP_ANDROID_URL} className="btn btn-light border border-gray-300 d-flex align-items-center justify-content-center gap-2">
              <img src={toAbsoluteUrl('/media/svg/brand-logos/google-play-store.svg')} alt="" style={{ height: 20 }} />
              <span className="fw-bold">
                Google Play'den <span className="text-primary">indir</span>
              </span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default AppDownloadRedirect;
